import { ThemeInterface } from "@styles/theme";

export const styles = (theme: ThemeInterface) => {
	return {
		button: {
			// width: "288px",
			height: "40px",
			borderRadius: "4px",
			backgroundColor: theme.palette.primary.main,
			"&:hover": {
				backgroundColor: theme.palette.primary.main,
			},
		},
		buttonPrimary: {
			color: theme.palette.common.white,
			backgroundColor: theme.palette.primary.main,
			"&:hover": {
				backgroundColor: theme.palette.primary.main,
			},
		},
		buttonSecondary: {
			// width: "288px",
			height: "40px",
			borderRadius: "4px",
			backgroundColor: theme.palette.common.white,
			border: `solid 1px ${theme.palette.primary.main}`,
			"&:hover": {
				backgroundColor: theme.palette.common.white,
				boxShadow:
					"0 1px 2px 1px rgb(71, 140, 219, 0.32), 0 2px 16px 2px rgb(71, 140, 219, 0.26), 0 1px 4px 0 rgb(71, 140, 219, 0.16) !important",
			},
		},
		buttonSecondaryDisable: {
			// width: "288px",
			height: "40px",
			borderRadius: "4px",
			backgroundColor: `${theme.palette.common.white} !important`,
			opacity: "1 !important",
			border: "solid 1px rgba(0,0,0,.2) !important",
			marginTop: "16px",
			marginBottom: "16px",
			marginLeft: "8px",
			marginRight: "8px",
		},
		textTypeButton: {
			minWidth: "120px",
			height: "40px",
			borderRadius: "2px",
			opacity: "1 !important",
		},
		buttonText: {
			fontWeight: "bold",
			fontSize: "14px",
			color: theme.palette.common.white,
		},
		buttonTextDisable: {
			color: theme.palette.secondary.light,
			fontWeight: "bold",
			fontSize: "14px",
		},
		secondaryButtonText: {
			fontWeight: "bold",
			fontSize: "14px",
			color: theme.palette.primary.main,
		},
		secondaryButtonTextDisable: {
			color: theme.palette.blueGrey.main,
			fontWeight: "bold",
			fontSize: "14px",
		},
		textTypeButtonText: {
			fontWeight: "600",
			fontSize: "14px",
			color: theme.palette.primary.main,
		},
		textTypeButtonTextDisable: {
			fontWeight: "600",
			fontSize: "14px",
			color: theme.palette.secondary.light,
		},
		iconButton: {
			cursor: "pointer",
			display: "inline",
			color: theme.palette.secondary.light,
		},
		iconGreen: {
			color: theme.palette.success.main,
		},
		iconRed: {
			color: theme.palette.error.light,
		},
		dangerSmall: {
			width: "140px",
			backgroundColor: theme.palette.error.light,
			"&:hover": {
				boxShadow:
					"0 1px 2px 1px rgba(236, 116, 116, 0.32), 0 2px 16px 2px rgba(236, 116, 116, 0.26), 0 1px 4px 0 rgba(236, 116, 116, 0.16) !important",
				backgroundColor: theme.palette.error.light,
			},
		},
		infoSmall: {
			width: "140px",
			backgroundColor: theme.palette.common.white,
			color: `${theme.palette.primary.main}`,
			"&:hover": {
				boxShadow: "none !important",
				backgroundColor: theme.palette.common.white,
			},
		},
		small: {
			width: "140px",
		},
		width168: {
			width: "168px",
		},
		width140: {
			width: "140px",
		},
		width80: {
			width: "80px",
		},
		widthFull: {
			width: "100%",
		},
		widthAuto: {
			width: "auto",
		},
		width88: {
			width: "88px",
			minWidth: "unset !important",
		},
		danger: {
			backgroundColor: theme.palette.error.light,
			"&:hover": {
				boxShadow:
					"0 1px 2px 1px rgba(236, 116, 116, 0.32), 0 2px 16px 2px rgba(236, 116, 116, 0.26), 0 1px 4px 0 rgba(236, 116, 116, 0.16) !important",
				backgroundColor: theme.palette.error.light,
			},
		},
		info: {
			backgroundColor: `${theme.palette.primary.main}`,
			"&:hover": {
				boxShadow: `0 1px 2px 1px ${theme.palette.primary.light}, 0 2px 16px 2px ${theme.palette.primary.light}, 0 1px 4px 0 ${theme.palette.primary.light} !important`,
				backgroundColor: `${theme.palette.primary.main}`,
			},
		},
		grey: {
			backgroundColor: "#5d637b",
			"&:hover": {
				boxShadow:
					"0 1px 2px 1px rgba(93, 99, 123, 0.32), 0 2px 16px 2px rgba(93, 99, 123, 0.26), 0 1px 4px 0 rgba(93, 99, 123, 0.16) !important",
				backgroundColor: "#5d637b",
			},
		},
		success: {
			backgroundColor: theme.palette.success.main,
			"&:hover": {
				boxShadow:
					"0 1px 2px 1px rgba(113, 186, 68, 0.32), 0 2px 16px 2px rgba(113, 186, 68, 0.32), 0 1px 4px 0 rgba(113, 186, 68, 0.32) !important",
				backgroundColor: theme.palette.success.main,
			},
		},
		infoText: {
			color: `${theme.palette.primary.main}`,
		},
		groupButton: {
			border: "1px solid #747c97",
			borderRadius: "12px",
			background: theme.palette.common.white,
			padding: "6px 16px",
			minWidth: "unset",
			marginRight: "10px",
			marginBottom: "22px",
			textTransform: "capitalize",
		},
		groupButtonText: {
			fontSize: "14px",
			fontWeight: "600",
			lineHeight: "1.57",
			color: "#747c97",
		},
		groupButtonActive: {
			border: `1px solid ${theme.palette.primary.main}`,
			background: `${theme.palette.primary.main}`,
			"&:hover": {
				background: `${theme.palette.primary.main}`,
				opacity: ".9",
			},
		},
		groupButtonTextActive: {
			color: theme.palette.common.white,
		},
		outcomeOptionButton: {
			marginBottom: "12px",
		},
		textTypeButtonDisabled: {
			backgroundColor: "rgba(0,0,0,0)",
		},
		textTypeButtonRoot: {
			color: "red",
		},
	};
};
export default styles;
